import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import axios, { AxiosResponse } from 'axios';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';

type KimInfo = {
  id: string;
  totalSupply: string;
  circulatingSupply: string;
  burnSupply: string;
  maxSupply: string;
  price: string;
  marketCap: string;
  circulatingMarketcap: string;
  fdv: string;
  xKimTotalSupply: string;
  xKimSupplyShare: string;
};

async function fetcher(config: ApplicationConfig | undefined) {
  const { data } = await axios.get<void, AxiosResponse<KimInfo>>(
    `${config?.URLS.middlewareUrl}/kim-token`
  );

  return data;
}

export function useKimInfo() {
  const config = useConfig();

  return useQuery([QueryKeys.KIM_INFO], () => fetcher(config));
}
